import React from 'react';
import { CardBenefitPartner as SimbaCardBenefitPartner } from '@naf-simba/sections-cards';
import { useCloudinary } from '../../hooks/Cloudinary/useCloudinary';
import { getBenefitLink, getDisplayContent, getDisplayImage, getDisplayLogo } from './CardBenefitPartner.utils';
import { useCardBenefitFavorite } from './useCardBenefitFavorite';
import { CardBenefitPartnerProps } from './CardBenefitPartner.types';

const CardBenefitPartner = ({
  benefit,
  img,
  isFlexible = false,
  limitIngress = true,
  matchedDepartment,
  onFavoriteChange,
  disableFavorite = false,
}: CardBenefitPartnerProps) => {
  const { image, slug, id, isLocalContent, abTestExperimentSlug, partner } = benefit;
  const itemSlug = slug || id;
  const { getProcessedImage } = useCloudinary();
  const { canFavorite, isFavorited, toggleFavorite } = useCardBenefitFavorite(
    benefit,
    disableFavorite,
    onFavoriteChange,
  );

  const cldImageUrl = getProcessedImage(image?.publicId, {
    width: 400,
    height: 211,
    focusMethod: image?.focus,
  })?.toURL();

  const departmentSlug = isLocalContent ? (matchedDepartment?.slug ?? benefit?.slug) : undefined;
  // Handle benefit link generation, either local department or global.
  const link = getBenefitLink({ isLocalContent, departmentSlug, slug, itemSlug, abTestExperimentSlug });

  const { displayTitle, displayIngress, displayDiscountBadge, campaignText } = getDisplayContent(benefit);
  const displayImage = getDisplayImage({ benefit, cldImageUrl, img });

  return (
    <SimbaCardBenefitPartner
      title={displayTitle}
      ingress={displayIngress}
      image={displayImage}
      logo={getDisplayLogo(partner)}
      link={{ to: link }}
      campaignText={campaignText}
      discountBadge={displayDiscountBadge}
      isFlexible={isFlexible}
      limitIngress={limitIngress}
      isFavorite={canFavorite ? isFavorited : undefined}
      favoriteAriaLabel={isFavorited ? 'Fjern fra favoritter' : 'Legg til i favoritter'}
      onFavoriteClick={canFavorite ? toggleFavorite : undefined}
    />
  );
};

export default CardBenefitPartner;
